/* ============================================================
   BloomUp — cart drawer extras
   - moves the tier bar to the top, celebrates a completed milestone
   - keeps the upsell row alive across re-renders
   - free gift picker
   - relabels the checkout button to "Pay Now"
   ============================================================ */
(function () {
  "use strict";

  var PAY_LABEL = "Pay Now";

  var cachedBlock = null;
  var cachedSeed = null;
  var fetching = false;
  var lastDone = null;

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function drawer() { return document.querySelector("#CartDrawer"); }
  function scroller() { return document.querySelector("#CartDrawer .bu-reco-scroller"); }
  function reduced() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null && getComputedStyle(el).position !== "fixed") return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function drawerOpen() {
    var d = drawer();
    if (!d) return false;
    if (d.hasAttribute("open") || d.open) return true;
    if (d.classList.contains("is--opened")) return true;
    return isVisible(d);
  }
  function productPath(href) {
    if (!href) return "";
    var m = String(href).split("?")[0].match(/\/products\/[^/]+/);
    return m ? m[0] : "";
  }

  /* ---------------- checkout button label ---------------- */
  /* GoKwik renders its own button text, so walk the text nodes and swap any
     "checkout" wording. Runs again after every drawer render. */
  function relabelCheckout() {
    var d = drawer();
    if (!d) return;
    var native = d.querySelector(".bu-native-checkout");
    if (native && native.textContent.trim() !== PAY_LABEL) native.textContent = PAY_LABEL;

    var gkButtons = d.querySelectorAll(".gokwik-checkout button");
    for (var i = 0; i < gkButtons.length; i++) {
      var walker = document.createTreeWalker(gkButtons[i], NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var txt = node.nodeValue;
        if (!txt) continue;
        if (/check\s*out/i.test(txt)) {
          node.nodeValue = txt.replace(/check\s*out/gi, PAY_LABEL);
        }
      }
    }
  }

  /* ---------------- tier bar ---------------- */
  function placeTiers() {
    var d = drawer();
    if (!d) return;
    var bar = d.querySelector("[data-bu-tier]");
    if (!bar) return;
    var items = d.querySelector(".hdt-mini-cart__items");
    if (!items || !items.parentNode) return;
    if (items.previousElementSibling !== bar) {
      items.parentNode.insertBefore(bar, items);
    }
    checkMilestone(bar);
  }
  function checkMilestone(bar) {
    var done = parseInt(bar.getAttribute("data-bu-done"), 10);
    if (isNaN(done)) return;
    if (lastDone !== null && done > lastDone) celebrate(bar);
    lastDone = done;
  }
  function celebrate(bar) {
    if (reduced()) return;
    var dots = bar.querySelectorAll(".bu-tier-dot.is-reached");
    var target = dots.length ? dots[dots.length - 1] : bar;
    var burst = document.createElement("span");
    burst.className = "bu-pop";
    var colors = ["#12a150", "#F97316", "#2A3B8F", "#FBBF24", "#EC4899"];
    var html = "";
    for (var i = 0; i < 14; i++) {
      var angle = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
      var dist = 26 + Math.random() * 26;
      var x = Math.round(Math.cos(angle) * dist);
      var y = Math.round(Math.sin(angle) * dist);
      var c = colors[i % colors.length];
      var delay = Math.round(Math.random() * 70);
      html += '<i style="--bu-x:' + x + "px;--bu-y:" + y + "px;background:" + c + ";animation-delay:" + delay + 'ms"></i>';
    }
    burst.innerHTML = html;
    target.appendChild(burst);
    target.classList.add("bu-pop-scale");
    setTimeout(function () {
      burst.remove();
      target.classList.remove("bu-pop-scale");
    }, 1000);
  }

  /* ---------------- upsell row ---------------- */
  function prune(block) {
    var d = drawer();
    if (!d || !block) return;
    var inCart = {};
    d.querySelectorAll(".hdt-mini-cart__item .hdt-mini-cart__title[href]").forEach(function (a) {
      var p = productPath(a.getAttribute("href"));
      if (p) inCart[p] = true;
    });
    block.querySelectorAll(".bu-reco-card").forEach(function (card) {
      var link = card.querySelector("a[href]");
      var p = productPath(link ? link.getAttribute("href") : "");
      if (p && inCart[p]) card.remove();
    });
  }
  function remember() {
    var b = document.querySelector("#CartDrawer .bu-reco-wrap");
    if (!b) return;
    cachedBlock = b;
    cachedSeed = b.getAttribute("data-bu-reco-seed") || "curated";
  }
  function ensureRow() {
    var d = drawer();
    if (!d) return;
    var live = d.querySelector(".bu-reco-wrap");
    if (live) { remember(); return; }
    var slot = d.querySelector(".bu-reco-auto[data-bu-reco-seed]");
    var seed = slot ? slot.getAttribute("data-bu-reco-seed") : null;
    if (cachedBlock && slot && cachedSeed === seed) {
      slot.replaceWith(cachedBlock);
      prune(cachedBlock); mountArrows(); watchScroller(); kick();
      return;
    }
    if (cachedBlock && !slot && cachedSeed) {
      var giftBlock = d.querySelector("[data-bu-gift]");
      var itemsCard = d.querySelector(".hdt-mini-cart__items");
      if (giftBlock && giftBlock.parentNode) giftBlock.parentNode.insertBefore(cachedBlock, giftBlock);
      else if (itemsCard && itemsCard.parentNode) itemsCard.parentNode.insertBefore(cachedBlock, itemsCard.nextSibling);
      else return;
      prune(cachedBlock); mountArrows(); watchScroller(); kick();
      return;
    }
    if (slot) fetchAuto(slot, seed);
  }
  function fetchAuto(slot, seed) {
    if (!seed || fetching || slot.getAttribute("data-bu-done") === seed) return;
    fetching = true;
    fetch("/recommendations/products?section_id=bloomup-reco&limit=10&intent=related&product_id=" + encodeURIComponent(seed), { headers: { Accept: "text/html" } })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        fetching = false;
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var block = doc.querySelector(".bu-reco-wrap");
        var current = document.querySelector("#CartDrawer .bu-reco-auto[data-bu-reco-seed='" + seed + "']");
        if (!current) return;
        if (!block) { current.setAttribute("data-bu-done", seed); return; }
        block.setAttribute("data-bu-reco-seed", seed);
        current.replaceWith(block);
        cachedBlock = block; cachedSeed = seed;
        prune(block); mountArrows(); watchScroller(); kick();
      })
      .catch(function () { fetching = false; });
  }

  /* ---------------- carousel arrows + autoscroll ---------------- */
  function mountArrows() {
    var wrap = document.querySelector("#CartDrawer .bu-reco-wrap");
    if (!wrap) return;
    var head = wrap.querySelector(".hdt-minicart-recommendations-heading");
    if (!head || head.querySelector(".bu-reco-nav")) return;
    var nav = document.createElement("div");
    nav.className = "bu-reco-nav";
    nav.innerHTML =
      '<button type="button" class="bu-reco-arrow bu-reco-prev" aria-label="Previous"></button>' +
      '<button type="button" class="bu-reco-arrow bu-reco-next" aria-label="Next"></button>';
    head.appendChild(nav);
    updateArrows();
  }
  function updateArrows() {
    var el = scroller();
    var wrap = document.querySelector("#CartDrawer .bu-reco-wrap");
    if (!el || !wrap) return;
    var prev = wrap.querySelector(".bu-reco-prev");
    var next = wrap.querySelector(".bu-reco-next");
    var max = el.scrollWidth - el.clientWidth;
    var settled = el.clientWidth > 0 && el.scrollWidth > 0;
    if (prev) prev.disabled = settled ? el.scrollLeft <= 4 : false;
    if (next) next.disabled = settled ? el.scrollLeft >= max - 4 : false;
  }
  var ro = null, watched = null;
  function watchScroller() {
    var el = scroller();
    if (!el || el === watched) { updateArrows(); return; }
    watched = el;
    [0, 120, 350, 800, 1500].forEach(function (ms) { setTimeout(updateArrows, ms); });
    if (window.requestAnimationFrame) requestAnimationFrame(updateArrows);
    var imgs = el.querySelectorAll("img");
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete) continue;
      imgs[i].addEventListener("load", updateArrows, { once: true });
      imgs[i].addEventListener("error", updateArrows, { once: true });
    }
    if (window.ResizeObserver) {
      if (ro) ro.disconnect();
      ro = new ResizeObserver(function () { updateArrows(); });
      ro.observe(el);
      var track = el.querySelector(".hdt-slider__container");
      if (track) ro.observe(track);
    }
  }
  window.addEventListener("resize", function () { updateArrows(); });
  function cardStep(el) {
    var card = el.querySelector(".bu-reco-card");
    if (!card) return el.clientWidth * 0.8;
    var track = el.querySelector(".hdt-slider__container");
    var style = getComputedStyle(track || el);
    var gap = parseFloat(style.columnGap || style.gap || "10") || 10;
    return card.getBoundingClientRect().width + gap;
  }
  function slide(dir) {
    var el = scroller();
    if (!el) return;
    var delta = cardStep(el) * dir;
    try { el.scrollBy({ left: delta, behavior: "smooth" }); } catch (e) { el.scrollLeft += delta; }
    setTimeout(updateArrows, 350);
    setTimeout(updateArrows, 700);
  }
  document.addEventListener("scroll", function (e) {
    if (e.target && e.target.classList && e.target.classList.contains("bu-reco-scroller")) updateArrows();
  }, true);

  var INTERVAL = 3200, RESUME_AFTER = 6000, timer = null, pausedUntil = 0;
  function step() {
    if (Date.now() < pausedUntil || document.hidden) return;
    var el = scroller();
    if (!el || !isVisible(el)) return;
    var max = el.scrollWidth - el.clientWidth;
    if (max <= 4) return;
    var next = el.scrollLeft + cardStep(el);
    if (next >= max - 4) next = 0;
    try { el.scrollTo({ left: next, behavior: "smooth" }); } catch (err) { el.scrollLeft = next; }
    setTimeout(updateArrows, 350);
  }
  function pause() { pausedUntil = Date.now() + RESUME_AFTER; }
  function kick() { if (!timer && !reduced()) timer = setInterval(step, INTERVAL); }
  ["pointerdown", "touchstart", "wheel", "keydown"].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target && e.target.closest && e.target.closest("#CartDrawer .bu-reco-wrap")) pause();
    }, { passive: true });
  });
  document.addEventListener("mouseenter", function (e) {
    if (e.target && e.target.closest && e.target.closest("#CartDrawer .bu-reco-scroller")) pause();
  }, true);

  /* ---------------- free gift picker ---------------- */
  function giftSheetEl() {
    var d = drawer();
    if (!d) return null;
    var el = d.querySelector(".bu-gift-sheet");
    if (el) return el;
    el = document.createElement("div");
    el.className = "bu-gift-sheet";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-label", "Free gifts");
    el.innerHTML =
      '<div class="bu-gs-panel">' +
      '<div class="bu-gs-handle" role="button" aria-label="Close"></div>' +
      '<div class="bu-gs-head"><p class="bu-gs-title">Free gifts for you</p><p class="bu-gs-sub"></p></div>' +
      '<div class="bu-gs-body"></div>' +
      "</div>";
    d.appendChild(el);
    return el;
  }
  function openGiftSheet(card) {
    var dataEl = card.querySelector(".bu-gift-json");
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;
    var wrap = card.closest("[data-bu-gift]");
    var unlocked = wrap && wrap.getAttribute("data-bu-unlocked") === "true";
    var hasGift = wrap && wrap.classList.contains("has-gift");
    var msgEl = wrap ? wrap.querySelector(".bu-gift-msg") : null;
    var msg = msgEl ? msgEl.textContent.trim() : "";
    var sheet = giftSheetEl();
    if (!sheet) return;
    sheet.querySelector(".bu-gs-sub").textContent = unlocked
      ? (hasGift ? "You've already claimed a gift for this order." : "Choose your free gift")
      : msg;
    var img = data.image ? '<img src="' + esc(data.image) + '" alt="" loading="lazy">' : "";
    var disabled = !unlocked || hasGift;
    sheet.querySelector(".bu-gs-body").innerHTML = data.variants.map(function (v) {
      var btn;
      if (!v.available) btn = '<span class="bu-gs-sold">Sold out</span>';
      else if (disabled) btn = '<button type="button" class="bu-gs-add is-locked" disabled><span class="bu-gs-lock"></span>Add</button>';
      else btn = '<button type="button" class="bu-gs-add" data-id="' + v.id + '">Add</button>';
      return (
        '<div class="bu-gs-row">' +
        '<div class="bu-gs-media">' + img + "</div>" +
        '<div class="bu-gs-info"><p class="bu-gs-name">' + esc(data.title) + "</p>" +
        '<p class="bu-gs-variant">' + esc(v.title) + "</p>" +
        '<p class="bu-gs-price"><s>' + v.price + '</s> <span class="bu-gs-free">Free</span></p></div>' +
        '<div class="bu-gs-action">' + btn + "</div></div>"
      );
    }).join("");
    requestAnimationFrame(function () { sheet.classList.add("bu-open"); });
  }
  function closeGiftSheet() {
    var d = drawer();
    var sheet = d ? d.querySelector(".bu-gift-sheet") : null;
    if (sheet) sheet.classList.remove("bu-open");
  }

  /* ---------------- clicks ---------------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var arrow = t.closest("#CartDrawer .bu-reco-arrow");
    if (arrow) {
      e.preventDefault(); e.stopPropagation();
      pause();
      slide(arrow.classList.contains("bu-reco-prev") ? -1 : 1);
      return;
    }
    var opener = t.closest("#CartDrawer .bu-open-gift");
    if (opener) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var card = opener.closest(".bu-gift-card");
      if (card) openGiftSheet(card);
      return;
    }
    if (t.closest(".bu-gs-handle")) { closeGiftSheet(); return; }
    var gs = t.closest(".bu-gift-sheet");
    if (gs && !t.closest(".bu-gs-panel")) { closeGiftSheet(); return; }
    var add = t.closest(".bu-gs-add:not(.is-locked)");
    if (add) {
      e.preventDefault(); e.stopPropagation();
      var id = parseInt(add.getAttribute("data-id"), 10);
      if (!id) return;
      add.disabled = true;
      add.textContent = "Adding\u2026";
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: id, quantity: 1 }) })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          closeGiftSheet();
          if (window.BUCart && window.BUCart.rerender) window.BUCart.rerender();
          else window.location.reload();
        })
        .catch(function () { add.disabled = false; add.textContent = "Try again"; });
      return;
    }
  }, true);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.key === "Esc") {
      var open = document.querySelector("#CartDrawer .bu-gift-sheet.bu-open");
      if (open) { closeGiftSheet(); e.stopPropagation(); }
    }
  }, true);

  /* ---------------- init ---------------- */
  function refresh() {
    placeTiers();
    ensureRow();
    relabelCheckout();
    mountArrows();
    watchScroller();
    kick();
  }
  function init() {
    refresh();
    setTimeout(relabelCheckout, 1200);
    setTimeout(relabelCheckout, 3500);

    var host = document.querySelector("hdt-cart-drawer");
    if (host && window.MutationObserver) {
      new MutationObserver(function () {
        remember();
        placeTiers();
        ensureRow();
        relabelCheckout();
      }).observe(host, { childList: true, subtree: true });
    }
    var d = drawer();
    if (d && window.MutationObserver) {
      new MutationObserver(function () {
        if (drawerOpen()) refresh(); else closeGiftSheet();
      }).observe(d, { attributes: true, attributeFilter: ["open", "class"] });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();